import React, { useEffect, useMemo, useState } from "react";
import { Card, CardTitle } from "reactstrap";
import { Col, Row } from "../../../../../../../../components/Component";
import { PDFViewer } from "@react-pdf/renderer";
import DeliveryNotePDF from "../../../../../pdf/DeliveryNotePDF";

const DeliveryNotePDFStep = ({
  continue_processing_data,
  setWizardData,
  nextStep,
  weighBridgeFormData, // ✅ OPTIONAL: pass this in when you are ready
  wizardData,          // ✅ OPTIONAL: pass this in when you are ready
}) => {
  const [page_data, setpageData] = useState(continue_processing_data);

  useEffect(() => {
    setpageData(continue_processing_data);
  }, [continue_processing_data]);

  // ======================================================
  // WEIGHBRIDGE INTEGRATION (SAFE)
  // - Do NOT override backend data.
  // - Only inject selector ticket when backend ticket is missing.
  // - Pull from whichever place you already have it:
  //   1) continue_processing_data.weighbridge_ticket_data
  //   2) weighBridgeFormData.weighbridge_ticket_data
  //   3) wizardData.weighbridge_ticket_data
  // ======================================================
  const mergedPageData = useMemo(() => {
    const base = page_data || {};

    const backendHasTicket = !!base?.weigh_bridge_ticket;
    if (backendHasTicket) return base;

    const selectorTicket =
      base?.weighbridge_ticket_data ||
      weighBridgeFormData?.weighbridge_ticket_data ||
      wizardData?.weighbridge_ticket_data ||
      null;

    if (!selectorTicket) return base;

    return {
      ...base,
      // this is what the updated DeliveryNotePDF reads when backend isn't ready
      weighbridge_ticket_data: selectorTicket,
    };
  }, [page_data, weighBridgeFormData, wizardData]);

  return (
    <>
      <Card className="card-inner">
        <CardTitle tag="h5">Delivery Note PDF</CardTitle>

        <Col lg="12">
          <div className="form-group d-flex justify-between">
            <div className="form-group">
              <div className="form-label-group">
                <label className="form-label text-soft">User Account :</label>
              </div>
              <div className="form-control-wrap">
                <label className="form-label text-primary">
                  {mergedPageData?.consigner?.name
                    ? `${mergedPageData?.consigner?.name} - ${mergedPageData?.user_account?.unique_identification_number}`
                    : "--"}
                </label>
              </div>
            </div>
          </div>
        </Col>

        <Row className="g-4">
          <div style={{ height: "90vh", width: "100%" }} className="border-2 border-text-gray-400">
            <PDFViewer height="100%" width="100%" showToolbar>
              <DeliveryNotePDF page_data={mergedPageData} />
            </PDFViewer>
          </div>
        </Row>
      </Card>
    </>
  );
};

export default DeliveryNotePDFStep;